module.exports = __webpack_public_path__ + "img/arrow-drop.7e8e31b4.svg";